<template>
  <div>
    <v-flex p-t-30>
      <div class="tituloBox p-b-30 border-top">
        <div class="bg-primary barraTitulo"></div>
        <h1 class="text-info font-size-18">
          Cadastrar
          <strong>Formulários e declarações</strong>
        </h1>
      </div>
    </v-flex>
    <v-flex>
      <v-card>
        <v-layout row wrap class="p-t-10 p-b-20">
          <v-flex
            xs12
            sm12
            md12
            v-for="item in fornecedorDeclaracaoVm.lista.filter(x=>x.uploadDeclaracao.exibe)"
            :key="item.uploadDeclaracao.chave+''+item.uploadDeclaracao.tipoDocumento"
          >
            <v-toolbar class="toolbar__title" light height="50px"   >
                <v-toolbar-title class="toolbar__title" v-if="ValidaObrigatorio(item.uploadDeclaracao.descricao)">
                <h6 class="titulo" >{{item.uploadDeclaracao.descricao}}</h6>
              </v-toolbar-title>
              <v-toolbar-title class="toolbar__title" v-else-if="ValidaNaoObrigatorio(item.uploadDeclaracao.descricao)">
                <h6 class="titulo" >{{item.uploadDeclaracao.descricao}}</h6>                
              </v-toolbar-title>
              <v-toolbar-title class="toolbar__title" v-else>
                <h6 class="titulo" >{{item.uploadDeclaracao.descricao}}*</h6>                
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon  @click="openBox(item)">
                <v-icon color="primary">unfold_more</v-icon>
              </v-btn>
            </v-toolbar>

            <v-layout wrap v-show="isShow[item.uploadDeclaracao.chave+''+item.uploadDeclaracao.tipoDocumento] || aberto"  >

              <!-- 
                  TODO 
                  Colocar aqui o componente de Download com o tamanho de md6
                  criar um IF para cada exibição de documento pelo código
              -->

              <v-flex sm12 md6 >
                <!--Este If é para não aparecer o campo de procuração -->
                <!--Este If é para não aparecer o campo de Comprovante de Residência -->
                <!--  v-if="item.uploadDeclaracao.chave != ('Procuracao') " -->
                <div>   
                              
                    <textFieldDeclaracoesArquivos
                      v-if="[64,71,99,100].includes(item.uploadDeclaracao.tipDocumento)"    
                     
                      :label="'Modelo '+ item.uploadDeclaracao.descricao"
                      :arquivoUpload="item.uploadDeclaracao.arquivoUpload"
                      :arquivoUploadSituacao="item.uploadDeclaracao.uploadDeclaracaoSituacao"                      
                      :codDocumento="''+item.uploadDeclaracao.tipDocumento"  
                    ></textFieldDeclaracoesArquivos>
                 
                </div>                
              </v-flex><br>
           
              <v-flex xs12 sm8 md6>
                    
                <div class="inputIcon" v-show="!item.file.novo">
                  <TextFieldValidadorDelete
                    v-show="!item.file.novo"
                    :key="item.uploadDeclaracao.arquivoUpload === null ? Math.random() : item.uploadDeclaracao.arquivoUpload" 
                    :arquivoUpload="item.uploadDeclaracao.arquivoUpload"
                    :arquivoUploadSituacao="item.uploadDeclaracao.uploadDeclaracaoSituacao"
                    :idMotivoIndeferimentoArquivo="item.uploadDeclaracao.idMotivoIndeferimentoArquivo"
                    :codDocumento="''+item.uploadDeclaracao.tipDocumento"
                    :idFornecedor="model.numCgcFornecedor"
                    v-on:clear="iconDelete(item)"                     
                    v-on:aprovar="aprovar(item.uploadDeclaracao,2,item.uploadDeclaracao.dtVencimento)"
                    v-on:rejeitar="rejeitar(item.uploadDeclaracao,$event)"
                    :label="item.uploadDeclaracao.descricao + testeAsterisco(item.uploadDeclaracao.obrigatorio)"
                    clearable
                    :hint="ifuploadDeclaracaoAlterado(item.uploadDeclaracao.arquivoUpload,item.uploadDeclaracao.tipDocumento,'tipDocumento')"
                    persistent-hint
                  ></TextFieldValidadorDelete>                
                </div>
              
                
                <uploadFile
                  v-if="item.file.novo && item.uploadDeclaracao.tipDocumento != 99"
                  tamanhoMaximo="20MB"
                  :required="item.uploadDeclaracao.tipDocumento !== 119 
                    && model.flagEstrangeiro !== 1 
                    && model.tipFornecedor !== 'F' 
                    && item.uploadDeclaracao.obrigatorio
                    && item.file.novo"
                  :key="item.key"
                  :label="item.uploadDeclaracao.descricao + testeAsterisco(item.uploadDeclaracao.obrigatorio)"
                  v-model="item.file.arquivoUpload"
                  accept=".pdf, .PDF"
                  @input="arquivoEnquadramentoDesen"
                />


                
                <uploadFile
                  v-if="item.file.novo && item.uploadDeclaracao.tipDocumento == 99"
                  tamanhoMaximo="20MB"      
                   :key="item.key"
                  :label="item.uploadDeclaracao.descricao + testeAsterisco(item.uploadDeclaracao.obrigatorio)"
                  v-model="item.file.arquivoUpload"
                  accept=".pdf, .PDF"
                  @input="arquivoEnquadramento"
                  
                />
              </v-flex> 

              <!-- 99 = Declaração de Enquadramento -->                 
              <v-flex xs6 sm4 md4 v-if="item.uploadDeclaracao.tipDocumento == 99"> 
                <div v-if="model.tipoCertificado == 1"> 
                <!-- CRC                
                  <datePicker
                    v-if="model.balancoFinanceiro && model.balancoFinanceiro.dtBalanco"
                    v-model="item.uploadDeclaracao.dtVencimento"
                    :dataDefault="item.uploadDeclaracao.dtVencimento"
                    v-mask="maskData"
                    :rules="[
                      v => (item.uploadDeclaracao.arquivoUpload || item.file.arquivoUpload) ? (!!v || 'Este campo é obrigatório.') : true,
                      v => !v || obrigatoriedadeDocumento(item) || true,
                      v => validaDataVencida(v) || 'Data de Enquadramento vencida.'
                    ]"
                    :label="$t('label.dataValidade')+' *'"
                    :testarDataVencida="validaDataVencida()"
                    validate-on-blur
                    @change="() => handleDateChange99(item)"
                    :key="dtEmissaoKey"
                    :bloquearData="blockDate"
                  />
                  -->  
                 
                  <datePicker
                    v-if="model.balancoFinanceiro && model.balancoFinanceiro.dtBalanco"
                    v-model="item.uploadDeclaracao.dtVencimento"
                    :dataDefault="dataVencimento99 ? dataVencimento99 : item.uploadDeclaracao.dtVencimento"
                    v-mask="maskData"
                    :rules="[
                      v => (item.uploadDeclaracao.arquivoUpload || item.file.arquivoUpload) ? (!!v || 'Este campo é obrigatório.') : true,
                      v => !v || obrigatoriedadeDocumento(item) || true,
                      v => validaDataVencida(v) || 'Data de Enquadramento vencida.'
                    ]"
                    :label="$t('label.dataValidade')+' *'"
                    :testarDataVencida="validaDataVencida()"
                    validate-on-blur
                    @change="() => handleDateChange99(item)"
                    :key="dtEmissaoKey"
                    :bloquearData="blockDate"
                  />
                </div>

              
                <div v-else> <!-- CRS ou Candidato  -->             
                  <datePicker
                    v-model="item.uploadDeclaracao.dtVencimento"                    
                    :testarDataVencida="true"
                    v-mask="maskData"
                    :dataDefault="dataVencimento99 ? dataVencimento99 : item.uploadDeclaracao.dtVencimento"
                    :rules="validaUploadDeclaracaoDocs(item) ? (validacao.campoObrigatorio) : []"
                    :label="$t('label.dataValidade')+' *'"
                    :required="validaUploadDeclaracaoDocs(item)"  
                    @change="alteracaoValorCampo(item.uploadDeclaracao)"
                    validate-on-blur
                    persistent-hint
                    :clearable="true"
                    :key="dtEmissaoKey"
                    :bloquearData="blockDate"
                  />
                </div>
              </v-flex>

              <!-- 100 = Declaração de Desenquadramento --> 
              <v-flex xs6 sm4 md4 v-if="item.uploadDeclaracao.tipDocumento == 100">
                <datePicker
                  v-model="item.uploadDeclaracao.dtVencimento"
                  :dataDefault="item.uploadDeclaracao.dtVencimento"
                  :testarDataVencida="true"
                  v-mask="maskData"
                  :rules="[
                    v => (item.uploadDeclaracao.arquivoUpload || item.file.arquivoUpload) ? (!!v || 'Este campo é obrigatório.') : true,
                    v => !v || obrigatoriedadeDocumento(item) || true,
                    v => validaDataVencida(v) || 'Data de Desenquadramento vencida.'
                  ]"
                  :label="$t('label.dataValidade')+' *'"
                  :required="validaUploadDeclaracaoDocs(item)"  
                  @change="handleDateChange100(item), alteracaoValorCampo(item.uploadDeclaracao)"
                  validate-on-blur
                  persistent-hint
                  :clearable="true"
                  :bloquearData="blockDateDesen"
                  :key="dtEmissaoKey + 1"
                />
              </v-flex>
              <!-- 119 = Procuração -->
              <v-flex xs6 sm4 md4 v-if="item.uploadDeclaracao.tipDocumento == 119">
              <datePicker
                v-model="item.uploadDeclaracao.dtVencimento"
                :dataDefault="item.uploadDeclaracao.dtVencimento"
                :label="$t('label.dataValidade')"
                :required="false"
                @change="alteracaoValorCampo(item.uploadDeclaracao)"
                validate-on-blur
                persistent-hint
                :clearable="true"
                :key="'dtVencimento-119-' + item.uploadDeclaracao.chave + item.uploadDeclaracao.tipoDocumento + '-' + (item.uploadDeclaracao.dtVencimento || 'null')"
                :rules="[
                    v => !v || 
                        (item.uploadDeclaracao.uploadDeclaracaoSituacao !== 2) || 
                        validaDataVencida(v) || 
                        'Data de Validade da Procuração Vencida.'
                  ]"
                :testarDataVencida="true"
              />
              </v-flex>   
            </v-layout>

          </v-flex>
        </v-layout>

        <v-dialog v-model="dialog" max-width="355" :persistent="persistent">
                  <v-card>
                    <v-card-title class="headline">Atenção!</v-card-title>
                    <v-form>
                      <v-layout row wrap>
                        <v-flex xs12><br />
                          Deseja excluir o documento?
                        </v-flex>
                      </v-layout><br /><br />
                      <v-layout wrap p-b-10>
                        <v-flex xs12 sm6>
                          <v-btn @click="cancelarDialog()">Não</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-btn color="info" @click="apagarItem()" :loading="isLoading">Sim</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card>
                </v-dialog>
      </v-card>
    </v-flex>
  </div>
</template>
<script>
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import textFieldDeclaracoesArquivos from "../../../components/text-field-declaracoes-arquivos";
// import moment from 'moment';
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import uploadDeclaracaoService from "../../../services/uploadDeclaracaoService";
import analiseCampoAlterado from "./components/analiseCampoAlterado";
import TextFieldValidadorDelete from "../../../components/text-field-validador-delete.vue";

export default {
  name: "formularios-declaracoes",
  mixins: [util,analiseCampoAlterado],
  components: {
    /*Componentes utilizados*/
    textFieldDeclaracoesArquivos,
    TextFieldValidadorDelete
  },
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    fornecedorDeclaracaoVm: Object,
    enums: Object,
    OldModel: Object
  }, 
  computed: {
    formattedDate() {
      this.fornecedorDeclaracaoVm.lista.forEach((item) => {
        if (item.uploadDeclaracao && item.uploadDeclaracao.tipDocumento == 99) {
          if (this.item.uploadDeclaracao.dtVencimento) {
            return this.item.uploadDeclaracao.dtVencimento.split('T')[0];
          }
        }
      });
      return null;
    },
    isFieldRequired() {
      if(this.dataVencimento_30_06_2025_ != null) {
        return true;      
      }
      return this.dataVencimento_30_06_2025_ != null;
    },
    itensExibidos() {
      // Oculta 161/162 só na UI quando o Termo (150) estiver aprovado
      var termoAprovado = this.model.uploadDeclaracao &&
        this.model.uploadDeclaracao.some(function (x) {
          return x.tipoDocumento === 150 && x.uploadDeclaracaoSituacao === 2;
        });

      return this.fornecedorDeclaracaoVm.lista.filter(x => {
        const tipo = x.uploadDeclaracao.tipoDocumento;
        if (termoAprovado && (tipo === 161 || tipo === 162)) return false; // só esconder
        return x.uploadDeclaracao.exibe !== false; // demais regras de exibição
      });
    },
  },
  
  mounted() {  
    this.CriandoData();
    // Adicione um delay para garantir que o componente está montado
  },

  
  created() /*Metodo de start do componente*/{  
    this.carregarTela();    
    
    // Atribuindo data de vencimento do enquamento do bando de dados
    this.model.uploadDeclaracao.forEach((item) => {
      if (item.tipDocumento == 99) {
        this.dataVencimento99 = item.dtVencimento;       
      }
    });

    this.fornecedorDeclaracaoVm.lista.forEach((item) => {
      if (item.uploadDeclaracao && item.uploadDeclaracao.tipDocumento == 99 ) {                
        this.dataVencimentoEnquamentoBD = item.uploadDeclaracao.dtVencimento;
      }
    });

    this.fornecedorDeclaracaoVm.lista.forEach((item) => {
      if (item.uploadDeclaracao && item.uploadDeclaracao.tipDocumento == 100 ) {
        this.dataVencimentoDesEnquamentoBD = item.uploadDeclaracao.dtVencimento;
      }
    });    
    
    this.fornecedorDeclaracaoVm.lista.forEach((item) => {
      if (item.uploadDeclaracao && (item.uploadDeclaracao.tipDocumento == 99 || item.uploadDeclaracao.tipDocumento == 100 )) {
        if(item.uploadDeclaracao.dtVencimento == null || item.uploadDeclaracao.dtVencimento === '') {
          this.blockDate = false; // se existe arquivo não bloqueia
          this.blockDateDesen = false; // se existe arquivo não bloqueia
          
          const anoAtualMaisUm = new Date().getFullYear() + 1; // Obtém o ano atual e soma 1
          const ultimoDiaUtilDeJunho = this.getUltimoDiaUtilDeJunho(anoAtualMaisUm);

          this.dataVencimento_30_06_2025_ =  `${anoAtualMaisUm}-${this.zeroPad(6)}-${this.zeroPad(ultimoDiaUtilDeJunho)}`;
        }
      }
    });
    
    if (this.model.balancoFinanceiro && this.model.balancoFinanceiro.dtBalanco) {
      let dataOriginal = this.model.balancoFinanceiro.dtBalanco;
      let ano = dataOriginal.split("-")[0]; 
      this.anoValidadeBalanco = ano;
    } 
    
  },
  watch: { //Propriedades assistidas
    "model.uploadDeclaracao":{
      handler() { /*Se houver um novo valor*/
        this.carregarTela();
      }
    }
  },
  data() {//Declaracao de variaveis
    return {
      valorRef: '',
      dtVencimentoKey: 1,
      dialog: false,
      isShow: [],
      aberto: true,
      anoValidadeBalanco: '', // Ticket #188855
      dataVencimento_30_06_2025_: '',
      dataVencimentoEnquamentoBD: null,
      dataVencimentoDesEnquamentoBD : null,
      dtEmissaoKey: 0,
      blockDate: true,
      blockDateDesen: true,
      dataEscolhidaDMY: null,
      dataEscolhidaDesenDMY: null,
      dataVencimento99: null
    }
  },
  methods: {//Declaracao de todos os metodos
    arquivoEnquadramento(file) {
      if(file.filename != null || file.filename != '') {
        this.blockDate = false;
        this.fornecedorDeclaracaoVm.lista.forEach((x) => {
              if (x.uploadDeclaracao.tipDocumento === 100) {
                this.$set(x.uploadDeclaracao, 'arquivoUpload', null);
                this.$set(x.file, 'novo', false);
                this.$set(x.file, 'arquivoUpload', null);
                this.$set(x, 'key', Date.now());
              }
            });
            

          this.valorRef = this.fornecedorDeclaracaoVm.lista.find(
              (x) => x.uploadDeclaracao.tipDocumento === 100
            );
            this.apagarItem();
           // this.CriandoData();

        
            
      }
    },
    arquivoEnquadramentoDesen(file) {
      if(file.filename != null || file.filename != '') {
        this.blockDateDesen = false;   
        this.fornecedorDeclaracaoVm.lista.forEach((x) => {
              if (x.uploadDeclaracao.tipDocumento === 99) {
                this.$set(x.uploadDeclaracao, 'arquivoUpload', null);
               this.$set(x.file, 'novo', false);
               this.$set(x.file, 'arquivoUpload', null);
               this.$set(x, 'key', Date.now());
              }
            });
          this.valorRef = this.fornecedorDeclaracaoVm.lista.find(
            (x) => x.uploadDeclaracao.tipDocumento === 99
          );
            
          this.apagarItem();
          //this.CriandoData();
          
        
      }
    },

    CriandoData(){
      const anoAtualMaisUm = new Date().getFullYear() + 1; // Obtém o ano atual e soma 1
    const ultimoDiaUtilDeJunho = this.getUltimoDiaUtilDeJunho(anoAtualMaisUm);
    // Calcula a data ISO diretamente
    const dataISO = new Date(anoAtualMaisUm, 5, ultimoDiaUtilDeJunho).toISOString();

    this.fornecedorDeclaracaoVm.lista.forEach((item) => {
      if (item.uploadDeclaracao && (item.uploadDeclaracao.tipDocumento == 99)) {
        
       
        if(item.uploadDeclaracao.arquivoUpload === null || item.uploadDeclaracao.arquivoUpload === '') {
          this.blockDate = true;
          item.uploadDeclaracao.dtVencimento = null;     
          this.$set(item.uploadDeclaracao, 'dtVencimento', null);   
          this.dataVencimento99 = false;    
        } else {            
          item.uploadDeclaracao.dtVencimento = dataISO;
          this.$set(item.uploadDeclaracao, 'dtVencimento', dataISO);  
        }      
      
      }

      if (item.uploadDeclaracao && (item.uploadDeclaracao.tipDocumento == 100)) {
        if(item.uploadDeclaracao.arquivoUpload == null) {
          this.blockDateDesen = true;
        }

        if(item.uploadDeclaracao.arquivoUpload === null) {
          item.uploadDeclaracao.dtVencimento = null;   
          this.dataVencimento99 = false;     
          this.$set(item.uploadDeclaracao, 'dtVencimento', null);         
        } else {
          item.uploadDeclaracao.dtVencimento = dataISO;
          this.$set(item.uploadDeclaracao, 'dtVencimento', dataISO); 
        }                  
      }
    });

    this.dtEmissaoKey += 1;
    },

    obrigatoriedadeDocumento(item) {
      if (item.uploadDeclaracao.chave === "DeclaracaoEnquadramento"){
        return false;
      }
    },
      getUltimoDiaUtilDeJunho(ano) {
      let data = new Date(ano, 5, 30); // Mês 5 = junho (mês começa em 0)
      
      // Enquanto o dia não for útil (segunda a sexta), vai voltando um dia
      while (data.getDay() === 0 || data.getDay() === 6) {
        data.setDate(data.getDate() - 1);
      }
      
      return data.getDate(); // Retorna o dia do mês (1 a 31)
  },
  atualizaDatasVencimento(){
    const anoAtualMaisUm = new Date().getFullYear() + 1; // Obtém o ano atual e soma 1
      const ultimoDiaUtilDeJunho = this.getUltimoDiaUtilDeJunho(anoAtualMaisUm);
      // Calcula a data ISO diretamente
     
      let dataISO = new Date(anoAtualMaisUm, 5, ultimoDiaUtilDeJunho).toISOString();
      let dataISO_ = new Date(anoAtualMaisUm, 5, ultimoDiaUtilDeJunho).toISOString();      
    
      this.fornecedorDeclaracaoVm.lista.forEach((item) => {
        if (item.uploadDeclaracao && item.uploadDeclaracao.tipDocumento == 99 && item.uploadDeclaracao.arquivoUpload != null) {
          if(this.dataEscolhidaDMY != null) {
            dataISO = this.dataEscolhidaDMY;
          }
          item.uploadDeclaracao.dtVencimento = dataISO;
        }

        if (item.uploadDeclaracao && item.uploadDeclaracao.tipDocumento == 100 && item.uploadDeclaracao.arquivoUpload != null) {
          if(this.dataEscolhidaDesenDMY != null) {
            dataISO_ = this.dataEscolhidaDesenDMY;
          }
          item.uploadDeclaracao.dtVencimento = dataISO_;
        }
      });
      this.dtEmissaoKey += 1;
  },
    zeroPad(num) {
      return num.toString().padStart(2, '0');
  },
    validaDataVencida(data) {
  
      if (!data) return true;

      let dataAtual = new Date();
      let dataFormatada = dataAtual.toISOString().split('T')[0];      

      const partes = data.split('/');
      const novaData = `${partes[2]}-${partes[1]}-${partes[0]}`;
      
      if(novaData < dataFormatada) {        
        return false;
      }    
      
      return true;
    },
    handleDateChange99(item) {
      this.$nextTick(() => {
        this.alteracaoValorCampo(item.uploadDeclaracao);
        
        if(item.uploadDeclaracao.dtVencimento != null && item.uploadDeclaracao.dtVencimento != ''){
          const dataSelecionada = item.uploadDeclaracao.dtVencimento;          
          this.dataEscolhidaDMY = dataSelecionada + 'T03:00:00';      
          
          if(this.dataVencimentoEnquamentoBD != ""){
            const dataObj = new Date(this.dataVencimentoEnquamentoBD);
            const dataFormatada = dataObj.toISOString().split('T')[0];

            if(dataSelecionada !== dataFormatada) {
              item.uploadDeclaracao.uploadDeclaracaoSituacao = null;             
            }      
          }
        }
      });
    },

    handleDateChange100(item) {
      this.$nextTick(() => {
        this.alteracaoValorCampo(item.uploadDeclaracao);
        
        const dataSelecionada = item.uploadDeclaracao.dtVencimento;
        this.dataEscolhidaDesenDMY = dataSelecionada + 'T03:00:00';
        
        if(dataSelecionada != null && dataSelecionada != ""){
          const dataObj = new Date(this.dataVencimentoDesEnquamentoBD);
          const dataFormatada = dataObj.toISOString().split('T')[0];

          if(dataSelecionada !== dataFormatada) {
            item.uploadDeclaracao.uploadDeclaracaoSituacao = null;             
          }            
        }
      });
    },   
    
    iconDelete(doc) {
      this.dialog = true;
      this.valorRef = doc;
    },

    cancelarDialog() {
      this.dialog = false;
    },

    apagarItem() {
      var aa = this.valorRef;
      
      aa.file.novo = true; 
      aa.uploadDeclaracao.arquivoUpload = null; 
      aa.file.arquivoUpload=null; 
      aa.uploadDeclaracao.dtVencimento='';
      this.dtEmissaoKey++;
      this.dialog = false;
    },

    limparDataVenc() {
    
      this.dtEmissaoKey++;
    }, 
    baixarArquivo(arquivo) {
      //metodo para baixar os documentos
      const numCgcFornecedor = this.$verificaPerfilHabilitador()
        ? this.model.numCgcFornecedor.replace(/[\W_]+/g,"")
        : null;
      fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
    },
    testeAsterisco(valor) {
      return valor ? " *" : "";
    },
    openBox(item) {
      const flag = this.isShow.includes( item.uploadDeclaracao.chave+''+item.uploadDeclaracao.tipoDocumento ) ;
      if(flag){
        this.$set(this.isShow, item.uploadDeclaracao.chave + "" + item.uploadDeclaracao.tipoDocumento, !flag);
      }
      
    },
     ValidaObrigatorio(valor) {
      if(valor.toUpperCase() == 'PROCURAÇÃO' || valor.toUpperCase() == 'COMPROVANTE DE RESIDÊNCIA')
      {return true;}
      return false;
      },
     
    ValidaNaoObrigatorio(valor){
        if(valor.toUpperCase() === 'DECLARAÇÃO DE ENQUADRAMENTO' || valor.toUpperCase() === 'DECLARAÇÃO DE DESENQUADRAMENTO'){
          return true;
        }
          return false;
      },
    alteracaoValorCampo(dadosDocumento){
            
        let arrayDocs = this.model.uploadDeclaracao;
        let self = this; 
        arrayDocs.forEach(function (item){
          
            if (item.tipDocumento === dadosDocumento.tipDocumento){
                           
              item.uploadDeclaracaoSituacao = null;
              item.dtRejeicao = null;
              item.idMotivoIndeferimentoArquivo = null;
              self.$set(item, 'uploadDeclaracaoSituacao', null);
              self.$set(item, 'dtVencimento', dadosDocumento.dtVencimento);
            }  
        });
        //this.carregarTela();
  
      },

      validaUploadDeclaracaoDocs__(item) {
        if(item.uploadDeclaracao.descricao.toUpperCase() === 'DECLARAÇÃO DE ENQUADRAMENTO' && item.uploadDeclaracao.arquivoUpload !== null ){
               
        return false;
        }
      },

    validaUploadDeclaracaoDocs(item){      
      //verifica se existee upload nas declarações de enquandramento e desenquadramento caso existam torna a data de validade obrigatória.          

      // Se apenas o documento de Declaração de Enquadramento for anexado, a data de vencimento será obriga
      if(item.uploadDeclaracao.descricao.toUpperCase() === 'DECLARAÇÃO DE ENQUADRAMENTO' && item.uploadDeclaracao.arquivoUpload != null ){
        return true;
      }
      
      if((item.uploadDeclaracao.descricao.toUpperCase() === 'DECLARAÇÃO DE DESENQUADRAMENTO') || 
        (item.uploadDeclaracao.descricao.toUpperCase() === 'DECLARAÇÃO DE ENQUADRAMENTO')){
        let docsDeclaracao = this.fornecedorDeclaracaoVm.lista.filter(
        x=>x.uploadDeclaracao.exibe && 
        (x.uploadDeclaracao.descricao.toUpperCase() === 'DECLARAÇÃO DE ENQUADRAMENTO' ||
         x.uploadDeclaracao.descricao.toUpperCase() === 'DECLARAÇÃO DE DESENQUADRAMENTO'));
        
        //a data de nascimento só é obrigatoria caso hajam as duas declarações
        if (docsDeclaracao.length == 2) {
            if((docsDeclaracao[0].file) && (docsDeclaracao[1].file)) {

               if((docsDeclaracao[0].file.arquivoUpload == null) && 
                  (docsDeclaracao[0].uploadDeclaracao.arquivoUpload == null)) {  
                    
                  //  docsDeclaracao[0].uploadDeclaracao.dtVencimento = '';
                    return false;
                  }
               else if((docsDeclaracao[1].file.arquivoUpload == null) && 
                        (docsDeclaracao[1].uploadDeclaracao.arquivoUpload == null)) {
                          
                     // docsDeclaracao[1].uploadDeclaracao.dtVencimento = '';
                      return false;
                  }
               else {
                 return true;
               }
            }
        }
        return false;
      }
    },
formatarIsoParaBr(dataIso) {
  if (!dataIso) return null;
  const data = new Date(dataIso);
  if (isNaN(data.getTime())) return null;
  return data.toLocaleDateString('pt-BR'); // Retorna "21/05/2026"
},
    carregarTela() {
      // Método para carregar os possíveis documentos para cadastro em tela
      var lista = [];

      // Verifica se o Termo de Concordância está deferido
      const termoConcordancia = this.model.uploadDeclaracao.find(
        item => item.tipDocumento === 150 && item.uploadDeclaracaoSituacao === 2 // 150 = Termo de Concordância e Veracidade, 2 = Aprovado
      );

      this.enums.tipoUploadDeclaracao.filter(item => {
        let dec = {
          chave: item.chave,
          idUploadDeclaracao: null,
          idFornecSolicitacao: this.model.idFornecSolicitacao,
          tipDocumento: item.valor,
          uploadDeclaracaoSituacao: null,
          descricao: item.descricao,
          arquivoUpload: null,
          idMotivoIndeferimentoArquivo: null,
          obrigatorio: false,
          exibe: true
        };

        // Exclui documentos relacionados ao termo se ele estiver deferido
        if (
          termoConcordancia &&
          (item.valor === 161 || item.valor === 162) // 161 = Procuração - Termo, 162 = Doc. Identificação - Termo
        ) {
          dec.exibe = false;
        }

        if (this.model.flagEstrangeiro === '1') {
          // Se for estrangeiro
          dec.obrigatorio = false;
          if (dec.chave === 'Procuracao') {
            dec.obrigatorio = true;
            dec.descricao = this.$t('label.procuracaoEstrangeiro');
          }
          dec = this.verificaSupervenienciaEmpregador(dec);
        }

        // Testar se exibe o campo em tela
        if (!dec.obrigatorio && this.model.tipoCertificado === 3) {
          if (
            dec.chave === "DeclaracaoEmpregador" ||            
            dec.chave === "DeclaracaoEnquadramento" || 
            dec.chave === "DeclaracaoDesenquadramento"
          ) {
            dec.exibe = false;
          }
        }

        let mv = this.model.uploadDeclaracao.find(
          x => x.tipDocumento === item.valor
        );

        if (mv) {
          dec.arquivoUpload = mv.arquivoUpload;
          dec.uploadDeclaracaoSituacao = mv.uploadDeclaracaoSituacao;
          dec.idMotivoIndeferimentoArquivo = mv.idMotivoIndeferimentoArquivo;
          dec.idUploadDeclaracao = mv.idUploadDeclaracao;
         this.$set(dec, 'dtVencimento', mv.dtVencimento ? mv.dtVencimento.split('T')[0] : null);
         // dec.dtVencimento = mv.dtVencimento;
          dec.dtRejeicao = mv.dtRejeicao;
        }

        if (dec.chave !== "TermoConcordanciaVeracidadeSaeb" && dec.exibe === true) {  
          lista.push({
            uploadDeclaracao: dec,
            file: { arquivoUpload: null, novo: dec.arquivoUpload ? false : true }
          });
        }

        
      });

      this.fornecedorDeclaracaoVm.lista = lista;
      this.atualizaDatasVencimento();
    },

    /* verifica de é Declaração de Superveniência e
     certificado diferente de CRE */
    verificaCertificadoSuperveniencia(dec){
      if (dec.chave === "DeclaracaoSuperveniencia" ) {
        dec.obrigatorio = true;
      }

      return dec;
    },

    /* Declaração do Empregador, Declaração de Superveniência e
     certificado diferente de CRE */
     verificaSupervenienciaEmpregador(dec){
      if ((dec.chave === "DeclaracaoEmpregador" && this.model.tipoCertificado !== 3) || (dec.chave === "DeclaracaoSuperveniencia" ))
       {
        dec.obrigatorio = true;
      }
      return dec;
    },
    
    aprovar(itemLista, sit, _datavencimento) {
      // Comentado dia 18/10/2024, pois estava limpando com de data quando clicava em aprovar
      /*
      this.fornecedorDeclaracaoVm.lista.forEach((item) => {        
        if (item.uploadDeclaracao.tipDocumento == 99 && item.uploadDeclaracao.arquivoUpload != null) {   
          this.handleDateChange99(item);
        }
      });
      */
      
      // Clona o item da lista e ajusta a situação e outros campos necessários
      let model = Object.assign({}, itemLista);
      model.uploadDeclaracaoSituacao = sit;
      model.idMotivoIndeferimentoArquivo = null;
      
      // Chama o serviço de aprovação/rejeição
      uploadDeclaracaoService.aprovarRejeitar(model).then(response => {

      // Encontra o item retornado pelo backend com o mesmo tipDocumento
      const updatedItem = response.data.find(item => item.tipDocumento === model.tipDocumento);

      if (updatedItem) {
        // Atualiza apenas o campo uploadDeclaracaoSituacao, mantendo os outros campos inalterados
        this.model.uploadDeclaracao = this.model.uploadDeclaracao.map(item => {
          if (item.tipDocumento === updatedItem.tipDocumento) {
            // Atualiza apenas uploadDeclaracaoSituacao, e mantém dtVencimento e outros campos inalterados            
            return {
              ...item,
              dtVencimento: updatedItem.dtVencimento !== null ? updatedItem.dtVencimento : item.dtVencimento,
              uploadDeclaracaoSituacao: updatedItem.uploadDeclaracaoSituacao // Somente este campo será alterado
              // Nenhum outro campo será sobrescrito aqui
            };
          }          
          return item; // Mantém todos os outros itens da lista inalterados
        });
        this.$set(this.model, 'uploadDeclaracao', [...this.model.uploadDeclaracao]);
      }
      
      // Itera sobre a lista e atualiza o campo dtVencimento se o tipDocumento for igual
      this.model.uploadDeclaracao.forEach(item => {
        if (item.tipDocumento === model.tipDocumento) {
          item.dtVencimento = model.dtVencimento;
        }
      });
    
      this.carregarTela();
   

        if (sit == 2) {
          this.$toasted.success(this.$t("messages.cadastro.aprovadoComSucesso"));
        }
      });
    },

    rejeitar(itemLista,motivo) {
      //metodo para rejeitar o documento
      let model = Object.assign({},itemLista);
      model.uploadDeclaracaoSituacao = 1;
      model.idMotivoIndeferimentoArquivo = motivo;
      uploadDeclaracaoService.aprovarRejeitar(model).then(response => { /*resposta do servico*/        
        this.model.uploadDeclaracao = response.data; /*dados de retorno*/
        this.carregarTela();
        
        this.fnAcaoModalCancelar();
        this.$toasted.success(this.$t("messages.cadastro.rejeitadoComSucesso"));
      });
    },

    fnAcaoModalCancelar() {
      //metodo para cancelar o rejeite do documento antes da persistencia
      this.modelDialogRejeitar.open = false;
    }

  }
};
</script>
       
<style scoped >
  .titulo {

    text-transform:uppercase;
    font-weight:bold;
    color:#349fbe
    
  }
  
</style>